import {
    useFindOrganizationsMapStore,
    useMapRefStore,
    useMapStore,
} from "../store";
import { Suspense, useState } from "react";
export default function DEBUGBAR() {
    const selectedItem = useFindOrganizationsMapStore(
        (state) => state.selectedItem,
    );

    const map = useMapStore((state) => state.map);
    const baseStyle = {
        backgroundColor: "white",
        position: "absolute",
        zIndex: 1000,
    };
    const styleObject = {
        right: {
            ...baseStyle,
            top: 0,
            right: 0,
            width: "300px",
        },
        bottom: {
            ...baseStyle,
            bottom: 0,
            left: 0,
            width: "100vw",
            display: "flex",
            overflowX: "scroll",
            gap: "10px",
        },
    };
    const [style, setStyle] = useState(styleObject["right"]);

    const DEVMENUITEMS = {
        bransch: "bransch",
        selectedItem: "selectedItem",
        fairIsChecked: "fairIsChecked",
        inputValue: "inputValue",
        showSuggestions: "showSuggestions",
        organizations: "filtredOrganizationsData",
        organizationsLoading: "organizationsIsLoading",
        suggestions: "suggestionsData",
        suggestionsIsLoading: "suggestionsIsLoading",
        searchTerm: "searchTerm",
        showMap: "showMap",
        expandendResults: "expandendResults",
        mapRef: "mapRef",
    };
    const DEVMENUITEMSARRAY = Object.keys(DEVMENUITEMS);

    const DEV = import.meta.env.DEV;
    return (
        DEV && (
            <Suspense fallback={<div>Loading...</div>}>
                <div style={style}>
                    <h5>DEBUGBAR</h5>

                    {DEVMENUITEMSARRAY.map((item, idx) => {
                        return (
                            <pre key={idx}>
                                {item}:{" "}
                                <code>
                                    {JSON.stringify(
                                        useFindOrganizationsMapStore.getState()[
                                            item
                                        ] || useMapRefStore.getState()[item],
                                    )}
                                </code>
                            </pre>
                        );
                    })}
                    <pre>
                        Window.widht :{" "}
                        {JSON.stringify(window.innerWidth, null, 2)}
                    </pre>
                    <pre>
                        Window.height :{" "}
                        {JSON.stringify(window.innerHeight, null, 2)}
                    </pre>
                    <pre>{map && map.getZoom()}</pre>
                    <span style={{ width: 50 }}>
                        <button onClick={() => setStyle(styleObject["right"])}>
                            Right
                        </button>
                        <button onClick={() => setStyle(styleObject["bottom"])}>
                            Bottom
                        </button>
                    </span>
                </div>
            </Suspense>
        )
    );
}
